import { KuxFilteredCategoriesDTO, UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';

import { CollectionRailStoreV2 } from '../collection-rail/collection-rail-store-v2';

export class SeriesRailStoreV2 extends CollectionRailStoreV2 {
  subtype: UIDAPresentationTypeEnum.series_catch_up = UIDAPresentationTypeEnum.series_catch_up;
  protected _removeInvisible = false;
  constructor(categoryTree: KuxFilteredCategoriesDTO, parentCategoryTree: KuxFilteredCategoriesDTO, children?: []) {
    super(categoryTree, parentCategoryTree, children);
    // differes from collection rail only by having this prop set
    this.groupBy = 'SeriesID';
  }
}
